import c from 'classnames';
import { Card, Icon, Typography } from 'components';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';

import styles from './SidebarActionCard.module.scss';

export const SidebarActionCard = () => {
  const { currentKitId } = useCurrentKitAndTinyAccount();
  
  return (
    <Card
      variant='wrapper'
      clickable={{
        href: `/action-plan/${currentKitId}`,
        text: 'View Plan',
        isExternal: false,
      }}
      className={c(styles.card, styles.colorActions)}
    >
      <div className={c(styles.cardBackground, styles.actions)}>
        <div className={c(styles.cardContent)}>
          <div className={styles.titleContainer}>
            <Typography variant='heading-m' className={styles.title}>
              Your Action Plan is Ready
            </Typography>
            <Typography variant='label' className={styles.label}>
              View Plan
            </Typography>
          </div>
          <div className={styles.button}>
            <Icon name='chevronForward' size='s' />
          </div>
        </div>
      </div>
    </Card>
  );
};
